import { DeleteOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import { useSupporterRemove } from "hook/supporters/useSupporter";
import React, { useState } from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const TableRemove = ({ data }) => {
  // -------------------------- VAR -----------------------------
  const { loading, showConfirmDelete } = useSupporterRemove();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Tooltip title="Xoá nhân viên này">
      <Button
        onClick={() => showConfirmDelete(data)}
        icon={<DeleteOutlined />}
        type="text"
        shape="circle"
        danger
        loading={loading}
        disabled={loading}
      />
    </Tooltip>
  );
};
export default TableRemove;
